import { uiText } from '../../i18n/uiText';
import React from 'react';

export default function InternationalPhoneInput({ value, onValueChange, className = 'form-control', ...props }) {
  return <input {...props} className={className} type="tel" autoComplete="tel" value={value || ''} maxLength={40}
    title={uiText("Для иностранного номера укажите +код страны. Российские номера можно вводить как раньше.")}
    placeholder={uiText("Например: +994 50 123 45 67")} onChange={e => onValueChange?.(e.target.value)} />;
}
